import React, { useEffect, useState } from "react";

import MapaBrasil from "./MapaBrasil";

// Sequência da abertura (ms a partir da montagem). O momento mais informativo é
// o destaque da região — é o que responde "onde eu estou?" —, então ele ganha
// 800ms de leitura antes do zoom começar. Já o intervalo entre contorno e
// destaque é só a transição de um estado para o outro, sem nada novo para ler.
const T_CONTORNO = 1100; // o traço da região acende
const T_DESTAQUE = 1500; // a região preenche com a cor
const T_ZOOM = 2300; // começa a aproximação
const DURACAO_ZOOM = 2600; // casa com --tl-dur-zoom-mapa no CSS
const ESPERA_FINAL = 900; // respiro antes de sair

export const DURACAO_TOTAL_ABERTURA = T_ZOOM + DURACAO_ZOOM + ESPERA_FINAL;

/**
 * Abertura da trilha: mapa do Brasil em cinza, a região do aluno acende em dois
 * tempos e o mapa aproxima nela.
 *
 * @param {object}   regiao      { id, nome }
 * @param {Function} onConcluir  chamado ao fim da sequência
 */
function Abertura({ regiao, onConcluir }) {
  const [etapa, setEtapa] = useState("cinza");
  const [zoom, setZoom] = useState(false);

  useEffect(() => {
    const cronometros = [
      setTimeout(() => setEtapa("contorno"), T_CONTORNO),
      setTimeout(() => setEtapa("destaque"), T_DESTAQUE),
      setTimeout(() => setZoom(true), T_ZOOM),
      setTimeout(onConcluir, DURACAO_TOTAL_ABERTURA)
    ];
    return () => cronometros.forEach(clearTimeout);
  }, [onConcluir]);

  return (
    <div className="abertura">
      <MapaBrasil regiaoId={regiao.id} etapa={etapa} zoom={zoom} />
      {/* O mapa já nomeia a região, então a legenda não repete o nome sozinha:
          preenche o silêncio da fase cinza e depois confirma a escolha. */}
      <div className="abertura__legenda" aria-live="polite">
        {etapa === "destaque"
          ? `Sua trilha começa no ${regiao.nome}!`
          : "Preparando sua trilha…"}
      </div>
      {/* Quem já viu a abertura não deve ser obrigado a esperar de novo — e em
          teste/QA é o que permite chegar na trilha sem cronômetro. */}
      <button type="button" className="abertura__pular" onClick={onConcluir}>
        Pular
      </button>
    </div>
  );
}

export default Abertura;
